import { render, staticRenderFns } from "./ReproductorVideo.vue?vue&type=template&id=2cd35d24&scoped=true&"
import script from "./ReproductorVideo.vue?vue&type=script&lang=js&"
export * from "./ReproductorVideo.vue?vue&type=script&lang=js&"
import style0 from "./ReproductorVideo.vue?vue&type=style&index=0&id=2cd35d24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd35d24",
  null
  
)

export default component.exports